import React from 'react';
import restaurantIcon from '../images/restaurant-icon.png';
import {trim_name} from '../utils.js';

const RestaurantMarker = (props) => {

  var short_name = trim_name(props.name, 2)

  return (
    <div><img src={ restaurantIcon } alt="rest" />{ short_name }</div>
  )
}

export default RestaurantMarker;
